export default "__VITE_ASSET__B$De90Ma__"